<template>
  <div v-if="citations && citations.length > 0" class="citations-banner">
    <button
      @click="isExpanded = !isExpanded"
      class="citations-header"
      type="button"
    >
      <div class="d-flex align-items-center justify-content-between w-100">
        <div class="d-flex align-items-center">
          <div class="citations-icon-container">
            <i class="fas fa-quote-right citations-quote-icon"></i>
          </div>
          <div class="d-flex flex-column align-items-start">
            <span class="citations-title">Citations</span>
            <span class="citations-count">{{ citationCountText }}</span>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <i
            :class="isExpanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
            class="citations-chevron"
          ></i>
        </div>
      </div>
    </button>

    <div v-show="isExpanded" class="citations-content">
      <div class="citations-list">
        <div
          v-for="(citation, index) in citations"
          :key="index"
          class="citation-item"
        >
          <a
            :href="getCitationUrl(citation)"
            target="_blank"
            rel="noopener noreferrer"
            class="citation-text-no-link"
          >
            <div class="citations-icon-container">
              <i class="fas fa-paperclip citations-paperclip-icon"></i>
            </div>
            <span>{{ getCitationName(citation) }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Citations',
  props: {
    citations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    citationCountText() {
      return this.citations.length === 1
        ? '1 result'
        : `${this.citations.length} results`;
    },
  },
  methods: {
    getCitationName(citation) {
      return [citation.document_name, citation.subtitle]
        .filter(Boolean)
        .join(' > ');
    },
    getCitationUrl(citation) {
      return citation.s3_url || '#';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@shared/styles/variables';
.citations-banner {
  margin-top: 12px;
  background-color: $lightest-gray;
  overflow: hidden;
  width: 100%;
}

.citations-header {
  padding: 12px 16px;
  text-decoration: none;
  color: $default-text;
  font-weight: 500;
  border: none;
  background: none;
  width: 100%;
}

.citations-title {
  font-size: 16px;
  font-weight: 400;
  color: $black;
}

.citations-count {
  margin-top: 2px;
  font-size: 14px;
  color: $dark-gray;
  font-weight: 400;
}

.citations-chevron {
  transition: transform 0.2s ease;
  color: $dark-gray;
}

.citations-icon-container {
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.citations-quote-icon {
  color: $black;
  font-size: 16px;
}

.citations-paperclip-icon {
  color: $black;
  font-size: 14px;
}

.citations-list {
  padding: 12px 16px;
  background-color: #f5f5f5;
}

.citation-item {
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
}

.citation-text-no-link {
  display: flex;
  align-items: center;
  color: $black;
  word-break: break-word;
  text-decoration: none;
  font-weight: 500;
}
</style>
